import buildPlayerGameStatusMutation from "../gql/mutations/buildPlayerGameStatusMutation";
import {ApolloError, useMutation} from "@apollo/client";

export const usePlayerGameStatusUpdate = (
  gameId: string,
  playerId: string,
  slot: number,
  displayName: string
): [(score: number, round: number, name?: string) => void, 
  { called: boolean; data: any | null | undefined; loading: boolean; error: ApolloError | undefined }] => {
  const mutation = buildPlayerGameStatusMutation(slot)

  const [updateMutation, { called, loading, error, data }] = useMutation(mutation)

  const updatePlayerStatus = (score: number, round: number, name?: string) => {
    updateMutation({variables: {
      id: gameId,
      playerId,
      playerDisplayName: name || displayName,
      score,
      round
    }})
  }
  return [updatePlayerStatus, { called, loading, error, data }]

}